// Arabic source phrases are also the keys for API and WebSocket errors.
// Keep user-written names, bios and messages outside this catalogue.
export const english: Record<string, string> = {
  انضمام: "Join",
  "من قائمة الحظر لديك في هذه المكالمة: {names}. يمكنك البقاء أو المغادرة. لن يعرفوا أنك حظرتهم.":
    "Blocked participants here: {names}. You can stay or leave. Your block stays private.",
  "، ": ", ",
  "إشعارات جديدة، {count}": "New notifications, {count}",
  "يمكن دعوة الأصدقاء المقبولين فقط.": "Only accepted friends can be invited.",
  "اختيار أصدقاء ودعوتهم": "Choose friends to invite",
  "دعوة أصدقاء": "Invite friends",
  "اختر حتى ١١ صديقًا. تصلهم دعوة للانضمام دون رنين.":
    "Choose up to 11 friends. They’ll get a quiet invitation to join.",
  "أضف أصدقاء لدعوتهم إلى مكالمة جماعية.":
    "Add friends to invite them to a group call.",
  "أُرسلت الدعوات.": "Invitations sent.",
  "إرسال الدعوات ({count})": "Send invitations ({count})",
  "ابدأ وادعُ ({count})": "Start and invite ({count})",
  "دعوات المكالمات الجماعية": "Group call invitations",
  "لم يوافق المنظّم على انضمامك إلى هذه المكالمة الجماعية.":
    "The organizer turned down your request to join this group call.",
  "في انتظار موافقة المنظّم…": "Waiting for the organizer’s approval…",
  "لم تنضم بعد. سيبدأ اتصالك تلقائيًا عند الموافقة، حتى لو كان المنظّم غائبًا الآن.":
    "You haven’t joined yet. You’ll connect automatically once approved. If the organizer is away, you’ll keep waiting.",
  "الموافقة على الانضمام": "Admission",
  "ينتظر القادمون موافقتك قبل الانضمام. الموجودون في المكالمة يستمرون كالمعتاد.":
    "New visitors wait for your approval. People already inside carry on as usual.",
  "طلب الموافقة قبل الانضمام": "Require approval to join",
  "في الانتظار": "Waiting to join",
  "لا أحد ينتظر الآن.": "Nobody is waiting right now.",
  "رفض {name}": "Turn away {name}",
  "قبول {name}": "Admit {name}",

  "أزالك المنظّم من هذه المكالمة الجماعية.":
    "The organizer removed you from this group call.",
  "كتم الميكروفون": "Mute microphone",
  "إزالة من المكالمة الجماعية": "Remove from group call",
  "إزالة {name} من المكالمة الجماعية؟": "Remove {name} from the group call?",
  "سينقطع اتصاله ولن يستطيع العودة إلى هذه المكالمة الجماعية، حتى بالرابط.":
    "They’ll be disconnected and won’t be able to return to this group call, even with the link.",
  "المكالمات الجماعية غير متاحة حاليًا. حاول لاحقًا. مكالماتك العادية تعمل كالمعتاد.":
    "Group calls aren't available right now. Try again later. Your other calls work as usual.",
  "انتهت هذه المكالمة الجماعية.": "This group call has ended.",
  "هذه المكالمة الجماعية ممتلئة. حاول لاحقًا.":
    "This group call is full. Try again later.",
  "هذا الإجراء لمنظّم المكالمة الجماعية فقط.":
    "Only the group call's organizer can do that.",
  "أنهى المنظّم المكالمة الجماعية.": "The organizer ended the group call.",
  "إنهاء للجميع": "End for everyone",
  "إنهاء المكالمة الجماعية للجميع؟": "End the group call for everyone?",
  "سينقطع الجميع وينتهي رابط المكالمة الجماعية.":
    "Everyone will be disconnected and the group link will stop working.",
  "في المكالمة الآن: {count}": "Inside now: {count}",
  "لا أحد في المكالمة الآن.": "Nobody is inside right now.",
  "رابط المكالمة الجماعية غير صحيح": "This group link isn't valid.",
  "بدء مكالمة جماعية": "Start a group call",
  "مكالمة جماعية": "Group call",
  مكتوم: "Muted",
  يتحدث: "Talking",
  "دعوة إلى مكالمة جماعية": "Group call invitation",
  "{name} يدعوك إلى مكالمة جماعية": "{name} invites you to a group call",
  "{name} يدعوك إلى مكالمة جماعية على رنّة":
    "{name} invited you to a group call on Ranna",
  "انضم باسمك فقط، دون بريد إلكتروني أو كلمة مرور.":
    "Join with just a name. No email or password needed.",
  "ستحصل على حساب في رنّة بهذا الاسم، دون بريد إلكتروني أو كلمة مرور.":
    "You’ll get a Ranna account under this name. No email or password needed.",
  "هذه مكالمتك الجماعية": "This is your group call",
  "انضم إلى المكالمة الجماعية": "Join group call",
  "أنشئ حسابًا للانضمام إلى هذه المكالمة الجماعية.":
    "Create an account to join this group call.",
  "رابط المكالمة الجماعية": "Group link",
  "انضم إلى مكالمتي الجماعية على رنّة": "Join my group call on Ranna",
  "مغادرة المكالمة الجماعية": "Leave group call",
  "جارٍ الانضمام…": "Joining…",
  "جارٍ إعادة الاتصال…": "Reconnecting…",
  "في المكالمة": "In the call",
  "شغّل الصوت": "Turn on sound",
  "انقطع اتصالك بالمكالمة الجماعية.":
    "You were disconnected from the group call.",
  "لا يمكن الانضمام دون الميكروفون. اسمح باستخدامه من إعدادات المتصفح.":
    "You need your microphone to join. Allow it in your browser's settings.",
  "أصوات التطبيق": "App sounds",
  "الرنين والمؤثرات ومستوى الصوت": "Ringing, effects and volume",
  "رنين المكالمات": "Call ringing",
  "رنين المكالمات الواردة وانتظار الرد داخل رنّة.":
    "Incoming calls and waiting for an answer in Ranna.",
  "المؤثرات الصوتية": "Sound effects",
  "نغمات للمكالمات والرسائل الجديدة. تصمت الرسائل أثناء المكالمة.":
    "Call cues and new messages. Messages stay quiet during calls.",
  "مستوى أصوات التطبيق": "App sound volume",
  "على هذا المتصفح. لا يغير صوت الطرف الآخر أو إشعارات النظام.":
    "For this browser. Your friend's audio and system alerts have their own volume.",
  "تجربة الأصوات": "Preview sounds",
  "مكالمة واردة": "Incoming call",
  "انتظار الرد": "Waiting for an answer",
  "بدء المكالمة": "Call connected",
  "نهاية المكالمة": "Call ended",
  "انقطاع الاتصال": "Connection interrupted",
  "عودة الاتصال": "Connection restored",
  "رسالة جديدة": "New message",
  "تجربة الأصوات متاحة بعد انتهاء المكالمة.":
    "You can preview sounds after the call.",
  "تعذر تشغيل الصوت. حاول مجددًا.": "Couldn't play the sound. Try again.",
  "جارٍ تشغيل: {sound}": "Playing: {sound}",
  "اختر صوتًا للاستماع إليه.": "Choose a sound to listen.",
  "لم تسمح بالإشعارات. اضغط تفعيل عندما تكون مستعدًا.":
    "Notification permission wasn’t granted. Try again when you’re ready.",
  "هذا الرمز غير صالح أو انتهت مدته.": "This code isn't valid or has expired.",
  "الدخول بهاتفك": "Sign in with your phone",
  "امسح الرمز بهاتف دخلت منه إلى حسابك على رنّة، أو أدخل الرمز في صفحة حسابك عليه.":
    "Scan this with a phone that's signed in to your Ranna account, or enter the code on its account page.",
  "رمز QR لتسجيل الدخول": "QR code to sign in",
  "جارٍ تجهيز الرمز…": "Getting a code…",
  "في انتظار موافقة هاتفك…": "Waiting for your phone to approve…",
  "انتهت مدة هذا الرمز.": "This code has expired.",
  "رمز جديد": "New code",
  "الدخول والأجهزة": "Sign-in and devices",
  "مفاتيح المرور ورمز الاستعادة وأجهزتك":
    "Passkeys, recovery code and your devices",
  "العودة إلى حسابك": "Getting back into your account",
  أجهزتك: "Your devices",
  "حالتك: {status}": "Your status: {status}",
  "أُضيف مفتاح المرور": "Passkey added",
  "حفظت الرمز": "I’ve saved it",
  "إذا فقدت هذا المتصفح فقدت هذا الحساب. أضف طريقة للعودة إليه.":
    "If you lose this browser, you lose this account. Add a way back in.",
  "الدخول من جهاز جديد": "Sign in on a new device",
  "اسمح لهاتف أو حاسوب آخر بالدخول إلى حسابك. بلا كلمة مرور، ولا شيء لتتذكره.":
    "Let another phone or computer into your account. No password, nothing to remember.",
  "افتح {host} على الجهاز الجديد": "Open {host} on the new device",
  "اختر تسجيل الدخول، ثم الدخول بهاتفك":
    "Choose Sign in, then Sign in with your phone",
  "امسح رمز QR بهذا الجهاز، أو أدخل رمزه هنا":
    "Scan its QR code with this device, or enter its code here",
  "إدخال رمز الجهاز": "Enter device code",
  إلغاء: "Cancel",
  "أدخل الرمز الظاهر على الهاتف أو الحاسوب الآخر.":
    "Enter the code shown on the other phone or computer.",
  "الدخول والأمان": "Sign-in & security",
  "لا حاجة لكلمة مرور": "No password needed",
  "المحفوظة: {count}": "{count} saved",
  "لم يُضف بعد": "None yet",
  محفوظ: "Saved",
  "غير محفوظ": "Not saved",
  "الأجهزة المسجّلة": "Signed-in devices",
  "النشطة: {count}": "{count} active",
  "مشاركة الحساب": "Share profile",
  "عضو منذ {date}": "Member since {date}",
  "رمز الجهاز": "Device code",
  إخراج: "Sign out",
  "إخراج الأجهزة الأخرى": "Sign out other devices",
  "هذا الجهاز": "This device",
  "جهاز غير معروف": "Unknown device",
  "آخر نشاط: {date}": "Last active: {date}",
  "إخراج {device}، آخر نشاط في {date}": "Sign out {device}, last active {date}",
  "دخول جديد إلى حسابك: {where}. إذا لم يكن هذا أنت، فأخرجه من «الدخول والأجهزة» في الإعدادات.":
    "New sign-in to your account: {where}. If this wasn’t you, sign it out from Sign-in and devices in Settings.",
  "أُنشئ رمز استعادة جديد لحسابك من جهاز آخر. إذا لم يكن هذا أنت، فافتح «الدخول والأجهزة» في الإعدادات وأخرج الأجهزة الأخرى، ثم أنشئ رمزًا جديدًا.":
    "A new recovery code was created for your account on another device. If this wasn’t you, open Sign-in and devices in Settings, sign out your other devices, then create a new code.",
  "أُضيف مفتاح مرور إلى حسابك من جهاز آخر. إذا لم يكن هذا أنت، فافتح «الدخول والأجهزة» في الإعدادات وأخرج الأجهزة الأخرى، ثم أزل مفتاح المرور هذا.":
    "A passkey was added to your account on another device. If this wasn’t you, open Sign-in and devices in Settings, sign out your other devices, then remove that passkey.",
  "سجّل الدخول للموافقة": "Sign in to approve",
  "سجّل الدخول على هذا الجهاز أولًا، ثم وافق على الجهاز الجديد.":
    "Sign in on this device first, then approve the new one.",
  "هل تريد إدخال هذا الجهاز إلى حسابك؟": "Let this device into your account?",
  "من يملك هذا الرمز يستطيع دخول حسابك. لا توافق إلا إذا كان هذا الجهاز أمامك.":
    "Anyone holding this code can get into your account. Approve only if this device is in front of you.",
  الجهاز: "Device",
  المكان: "Place",
  الوقت: "Time",
  موافقة: "Approve",
  "ليس أنا": "Not me",
  "تمت الموافقة": "Device approved",
  "سيدخل الجهاز إلى حسابك خلال لحظات.":
    "It will be in your account within a few seconds.",
  "تعذرت الموافقة": "Couldn't approve this device",
  "جارٍ التحقق من الرمز…": "Checking the code…",
  "العودة إلى الرئيسية": "Back to home",
  "تثبيت رنّة": "Install Ranna",
  "تطبيق رنّة": "Ranna app",
  "أنت تستخدم تطبيق رنّة. فعّل الإشعارات من الإعدادات.":
    "You’re using the Ranna app. Turn on notifications in Settings.",
  "لديك حساب في المتصفح؟ ادخل بمفتاح المرور أو رمز الاستعادة للاحتفاظ بأصدقائك.":
    "Already have an account in your browser? Sign in with your passkey or recovery code to keep your friends.",
  "على iPhone أو iPad، افتح رنّة في Safari، ثم مشاركة، ثم إضافة إلى الشاشة الرئيسية. افتح رنّة من الأيقونة لتفعيل الإشعارات. يتطلب iOS أو iPadOS 16.4 أو أحدث.":
    "On iPhone or iPad, open Ranna in Safari, tap Share, then Add to Home Screen. Open Ranna from its icon to turn on notifications. Requires iOS or iPadOS 16.4 or later.",
  "ثبّت رنّة من الزر أو من قائمة المتصفح: تثبيت التطبيق أو إضافة إلى الشاشة الرئيسية. ثم افتحه وفعّل الإشعارات من الإعدادات.":
    "Install Ranna using the button or your browser menu: Install app or Add to Home screen. Then open it and turn on notifications in Settings.",
  "ثبّت رنّة من الزر أو من قائمة المتصفح إذا كان التثبيت متاحًا، ثم فعّل الإشعارات من الإعدادات.":
    "Install Ranna using the button or your browser menu if installation is available, then turn on notifications in Settings.",
  "قبل التثبيت، أضف مفتاح مرور أو احفظ رمز الاستعادة من «الدخول والأجهزة». إذا طلب التطبيق الدخول، استخدم أيًا منهما؛ قد يكون دخوله منفصلًا عن المتصفح.":
    "Before installing, add a passkey or save a recovery code from Sign-in and devices. If the app asks you to sign in, use either one; its session may be separate from your browser.",
  "تحتاج رنّة إلى الإنترنت للمكالمات والرسائل. قد تتأخر الإشعارات بسبب الشبكة أو إعدادات النظام.":
    "Ranna needs internet for calls and messages. Network and system settings can delay notifications.",
  "تعذر فتح التثبيت. استخدم قائمة المتصفح لإضافة رنّة إلى الشاشة الرئيسية.":
    "Couldn’t open installation. Use your browser menu to add Ranna to your Home screen.",
  "تعذر تحديث الإشعارات. افتح رنّة وحاول مجددًا.":
    "Couldn’t renew notifications. Open Ranna and try again.",
  "تعذر تفعيل الإشعارات. تحقق من اتصالك وإعدادات الجهاز ثم حاول مجددًا.":
    "Couldn’t turn on notifications. Check your connection and device settings, then try again.",
  "أضف رنّة إلى الشاشة الرئيسية وافتحه من الأيقونة لتفعيل الإشعارات. يتطلب iOS أو iPadOS 16.4 أو أحدث.":
    "Add Ranna to your Home Screen and open it from the icon to turn on notifications. Requires iOS or iPadOS 16.4 or later.",
  "الإشعارات غير مدعومة هنا. استخدم متصفحًا حديثًا أو تطبيق رنّة المثبّت.":
    "Notifications aren’t supported here. Use a recent browser or the installed Ranna app.",
  "تعذر تحميل إعدادات الإشعارات. تحقق من اتصالك وحاول مجددًا.":
    "Couldn’t load notification settings. Check your connection and try again.",
  "جارٍ التحقق من إشعارات هذا الجهاز…": "Checking notifications on this device…",
  "الإشعارات محظورة. اسمح بها لرنّة في إعدادات إشعارات الجهاز ثم افتحه مجددًا.":
    "Notifications are blocked. Allow them for Ranna in your device’s notification settings, then reopen it.",

  "انتظر ٥ دقائق بعد إغلاق البلاغ السابق قبل إرسال بلاغ جديد عن هذا الشخص.":
    "Wait five minutes after the previous report closes before reporting this person again.",
  "اكتب سببًا أولًا": "Enter a reason first",
  "أكد الإجراء أولًا": "Confirm this action first",
  "هذا الحساب موقوف مؤقتًا": "This account is suspended",
  "لا يمكن تطبيق هذا الإجراء على حسابك أو حساب مشرف":
    "This can't be done to your own or an administrator's account",
  "لا يمكن حذف حساب مشرف": "An administrator's account can't be deleted",
  "لا يمكن إيقاف ضيف دون حساب": "A guest without an account cannot be suspended",
  "تغيرت الحالة. حدّث الصفحة وحاول مجددًا.":
    "The status changed. Refresh the page and try again.",
  "لا يمكنك الإبلاغ عن نفسك": "You cannot report yourself",
  "البلاغ غير موجود": "Report not found",
  "السجل غير موجود": "Audit record not found",
  الإبلاغ: "Report",
  "الإبلاغ عن {name}": "Report {name}",
  "ماذا حدث مع {name}؟": "What happened with {name}?",
  "لن يعرف {name} أن البلاغ منك.": "{name} won’t know this came from you.",
  "إزعاج أو إهانات": "Harassment or insults",
  "تهديد أو شعور بعدم الأمان": "Threats or feeling unsafe",
  "محتوى جنسي أو غير لائق": "Sexual or inappropriate content",
  "رسائل أو مكالمات مزعجة": "Spam or unwanted calls",
  "سبب آخر": "Something else",
  "إذا كنت في خطر الآن، فاتصل برقم الطوارئ في منطقتك.":
    "If you’re in danger right now, call your local emergency number.",
  "أخبرنا بما حدث": "Tell us what happened",
  "هل تود إضافة شيء؟ (اختياري)": "Anything you’d like to add? (optional)",
  "حظر {name}": "Block {name}",
  "لن تصلك مكالمات أو رسائل من هذا الحساب.":
    "No more calls or messages from this account.",
  "إرسال البلاغ": "Send report",
  "شكرًا لإخبارنا": "Thanks for telling us",
  "سنراجع ما حدث، ولن يعرف {name} أن البلاغ منك.":
    "We’ll look into it, and {name} won’t know this came from you.",
  "تم حظر {name}، ولن تصلك مكالمات أو رسائل من هذا الحساب.":
    "{name} is blocked, so no more calls or messages from this account.",
  تم: "Done",
  "يمكن للمشرف استعادة حسابك. احتفظ بهذه الجلسة ثم تحقق مجددًا، حتى إن لم يكن لديك مفتاح مرور أو رمز استعادة.":
    "An administrator can restore your account. Keep this session and check again, even if you have no passkey or recovery code.",

  "عرض فوق التبويبات": "Show over other tabs",
  "تعذر عرض المكالمة فوق التبويبات. اسمح بصورة داخل صورة في إعدادات المتصفح وحاول مجددًا.":
    "Couldn’t show the call over other tabs. Allow Picture-in-Picture in your browser settings and try again.",
  "تجاوز إلى المحتوى": "Skip to content",
  "ابدأ باسم مستعار. دون بريد إلكتروني أو رقم هاتف.":
    "Start with a nickname. No email or phone number needed.",
  "من الرابط إلى المكالمة": "From link to call",
  "ثلاث خطوات للبدء": "Three steps to your first call",
  "أنشئ رابط مكالمة": "Create a call link",
  "اختر اسمًا مستعارًا واحصل على رابطك بضغطة واحدة.":
    "Pick a nickname and get your link in one tap.",
  "أرسله لمن تريد": "Send it to anyone",
  "شاركه في أي تطبيق. يكتب اسمه وينضم دون حساب.":
    "Share it in any app. They type a name and join, no account needed.",
  "تحدثا وابقيا على تواصل": "Talk, then stay in touch",
  "اتصلا بالصوت أو الفيديو، ثم ابقيا على تواصل إن أردتما.":
    "Talk by voice or video, then stay in touch if you both want to.",
  "ابدأ مكالمة": "Start a call",
  "أنشئ رابطًا وأرسله لأي شخص، وتحدثا بالصوت أو الفيديو عندما يفتحه.":
    "Create a link, send it to anyone, and talk by voice or video when they open it.",
  "إنشاء رابط مكالمة": "Create call link",
  "رابط مكالمتك": "Your call link",
  "بانتظار من يفتح الرابط": "Waiting for someone to open it",
  "أرسله إلى شخص واحد. عندما يفتحه ستسمع رنّة هنا. صالح لمدة ٢٤ ساعة.":
    "Send it to one person. When they open it, Ranna rings here. Works for 24 hours.",
  "إلغاء الرابط": "Cancel link",
  "تم إلغاء الرابط": "Link cancelled",
  "انضم إلى مكالمتي على رنّة": "Join my call on Ranna",
  "اختر الاسم الذي يراه من يفتح رابطك.":
    "Pick the name people see when they open your link.",
  "دعوة إلى مكالمة": "Call invitation",
  "{name} يدعوك إلى مكالمة": "{name} invited you to a call",
  "{name} يدعوك إلى مكالمة على رنّة": "{name} invited you to a call on Ranna",
  "انضم بالصوت أو الفيديو باسمك فقط، دون بريد إلكتروني أو كلمة مرور.":
    "Join by voice or video with just a name. No email or password needed.",
  "ستنضم باسم {name}.": "You’ll join as {name}.",
  "سيصل إشعار إلى {name} عند انضمامك.":
    "{name} will get a notification when you join.",
  "انضم إلى المكالمة": "Join call",
  "انضم بالفيديو": "Join with video",
  "بعد المكالمة يمكنكما البقاء على تواصل إن أردتما.":
    "After the call, you can stay in touch if you both want to.",
  // A guest's call pass, from joining a link until it ends.
  "اتصل بـ{name} مجددًا": "Call {name} again",
  "سيصل إشعار إلى {name} عند اتصالك.":
    "{name} will get a notification when you call.",
  "يمكنك الاتصال مجددًا حتى تنتهي صلاحية الرابط.":
    "You can call again until the link expires.",
  "رُفضت المكالمة": "Call declined",
  "انتهى هذا الرابط. اطلب رابطًا جديدًا ممن أرسله إليك.":
    "This link has ended. Ask the person who sent it for a new one.",
  "انتهت المكالمة مع {name}": "Your call with {name} ended",
  "في مكالمة مع {name}": "On a call with {name}",
  "ابقَ على تواصل لتتصلا مجددًا لاحقًا. ستحصل على حساب ويمكنك إضافة {name} إلى أصدقائك.":
    "Stay in touch to call again later. You’ll get an account and can add {name} as a friend.",
  "ابقَ على تواصل": "Stay in touch",
  "جهّز حسابك": "Set up your account",
  "احتفظ بالاسم الذي انضممت به أو غيّره، واختر اسم مستخدم إن أردت.":
    "Keep the name you joined with or change it, and pick a username if you like.",
  "اختياري. حروف إنجليزية وأرقام وشرطة سفلية، وإن تركته فارغًا فسنختار لك واحدًا.":
    "Optional. Use letters a–z, numbers or underscores, or leave it empty and we’ll pick one.",
  تخطي: "Skip",
  "إضافة {name} إلى أصدقائك؟": "Add {name} as a friend?",
  "حسابك جاهز. أرسل طلب إضافة إلى {name} لتتمكنا من الاتصال والمراسلة بعد قبوله.":
    "Your account is ready. Send {name} a friend request so you can call and message each other once it’s accepted.",
  "إرسال طلب إضافة": "Send friend request",
  مغادرة: "Leave",
  "ضيف عبر رابطك": "Guest via your link",
  "أدخل اسمًا من حرفين على الأقل.": "Enter a name of at least two characters.",
  "تعذر إنشاء الحساب. حاول مجددًا.": "Couldn’t create the account. Try again.",
  "{name} غير متاح حاليًا. أبقِ الصفحة مفتوحة وتحقق بعد قليل.":
    "{name} isn’t available right now. Keep this page open and check again soon.",
  "تحقق مجددًا": "Check again",
  "رابط المكالمة غير متاح": "This call link isn’t available",
  "ربما انتهت صلاحيته أو استُخدم بالفعل. اطلب رابطًا جديدًا ممن أرسله إليك.":
    "It may have expired or already been used. Ask the person who sent it for a new one.",
  "الذهاب إلى رنّة": "Go to Ranna",
  "تعذر تحميل الدعوة.": "Couldn’t load this invitation.",
  "هذا رابط مكالمتك": "This is your call link",
  "رابط المكالمة غير متاح. ربما انتهت صلاحيته أو استُخدم بالفعل.":
    "This call link isn’t available. It may have expired or already been used.",
  "رابط المكالمة غير صحيح": "Invalid call link",
  "هذا رابط مكالمتك. أرسله إلى شخص آخر.":
    "This is your own call link. Send it to someone else.",
  "صاحب الرابط غير متاح حاليًا. حاول بعد قليل.":
    "The person who shared this link isn’t available right now. Try again soon.",
  "ابحث عن صديق": "Find a friend",
  "عن رنّة": "About Ranna",
  الخصوصية: "Privacy",
  "شروط الاستخدام": "Terms of use",
  "هذه الصفحة غير موجودة": "This page is out of reach",
  "قد يكون الرابط قد تغيّر. يمكنك العودة للبحث عن أصدقائك.":
    "The link may have changed. Head back to find your friends.",
  العودة: "Back",
  "بيانات الحساب والمحادثات": "Account and conversation data",
  "تُحفظ بيانات الاسم واسم المستخدم والنبذة، وطلبات الإضافة والصداقات والرسائل وسجل المكالمات، على خوادم التطبيق لتقديم الخدمة.":
    "Your name, username, bio, friend requests, friendships, messages and call history are stored on the app's servers to provide the service.",
  "الصوت والفيديو والشاشة": "Audio, video and screen sharing",
  "مكالماتك مشفّرة بينك وبين الطرف الآخر. لا تسجّل رنّة الصوت أو الفيديو أو محتوى الشاشة ولا تخزّنه. أنت تتحكّم في الميكروفون والكاميرا ومشاركة الشاشة، ويمكنك إيقافها في أي وقت.":
    "Your calls are encrypted between you and the other person. Ranna does not record or store audio, video or shared screen content. You control your microphone, camera and screen sharing, and can turn them off at any time.",
  "المتصفح والجلسة": "Your browser and session",
  "تستخدم رنّة ملف تعريف ارتباط للجلسة، وتحفظ اختيار اللغة وتفضيل تذكير الاستعادة في المتصفح. رمز الاستعادة لا يُحفظ تلقائيًا في تخزين المتصفح. مع مفتاح المرور تحفظ رنّة مفتاحًا عامًا فقط، ولا تصل إليها بصمتك أو وجهك أو قفل شاشتك. عندما يطلب جهاز جديد الدخول، تحفظ رنّة نوعه ومدينته التقريبية مع الطلب الذي يدوم خمس دقائق لتعرضهما عليك قبل الموافقة، ثم تحذف الطلبات المنتهية. وتحفظ النوع والمدينة، دون عنوان IP، مع كل جلسة ما دامت قائمة، ولا تعرضهما إلا على أجهزة حسابك.":
    "Ranna uses a session cookie and stores your language choice and recovery reminder preference in your browser. Recovery codes are not automatically saved in browser storage. With a passkey, Ranna keeps only a public key, and your fingerprint, face or screen lock never reach it. When a new device asks to sign in, Ranna keeps its type and approximate city with the request, which lasts five minutes, to show you before you approve, then deletes expired requests. It also keeps the type and city, not your IP address, with each session while it lasts, and shows them only to your account’s devices.",
  "من يرى نشاطك": "Who sees your activity",
  "يرى أصدقاؤك المقبولون حالة اتصالك وآخر ظهور لك وهل قرأت رسائلهم وفق إعداداتك. يمكنك إخفاء آخر ظهور وحالة القراءة أو اختيار الظهور كغير متصل من الإعدادات.":
    "Accepted friends see your online status, your last active time and whether you've read their messages, according to your settings. You can hide your last active time and read status, or appear offline, in settings.",
  "التواصل باختيار الطرفين": "Connecting by mutual choice",
  "تتاح الرسائل والمكالمات بعد قبول طلب الإضافة. احترم رغبة الآخرين، ولا تستخدم التطبيق للمضايقة أو انتحال الشخصية أو إرسال محتوى غير قانوني.":
    "Messages and calls are available after a friend request is accepted. Respect other people's choices. Do not use the app for harassment, impersonation or illegal content.",
  "حسابك وطرق العودة إليه": "Your account and getting back into it",
  "يمكنك استخدام اسم مستعار. أضف مفتاح مرور أو احتفظ برمز الاستعادة في مكان خاص إذا أردت العودة إلى الحساب من جهاز آخر أو بعد مسح بيانات المتصفح. من يمتلك الرمز يستطيع الدخول إلى الحساب.":
    "You can use a nickname. Add a passkey or keep your recovery code somewhere private to return on another device or after clearing browser data. Anyone with the code can access the account.",
  "الأذونات والتوفر": "Permissions and availability",
  "تحتاج المكالمات إلى متصفح متوافق واتصال بالإنترنت وأذونات الميكروفون أو الكاميرا بحسب اختيارك. تعتمد مشاركة الشاشة على دعم المتصفح، وقد تتعطل الخدمة أو ينقطع الاتصال.":
    "Calls need a compatible browser, an internet connection and microphone or camera permission as you choose. Screen sharing depends on browser support. The service may be unavailable or a connection may drop.",
  "إدارة من تتواصل معهم": "Managing your connections",
  "يمكنك إزالة صديق أو حظر حساب من خيارات المحادثة، وإدارة الحسابات المحظورة من الإعدادات. إزالة الصداقة توقف الرسائل والمكالمات بين الطرفين.":
    "You can remove a friend or block an account from the conversation menu, and manage blocked accounts in settings. Removing a friendship stops messages and calls between both people.",
  الرئيسية: "Home",
  الرسائل: "Messages",
  "البحث في المحادثات": "Search conversations",
  "اختر محادثة": "Select a conversation",
  "عرض حساب {name}": "View {name}'s profile",
  "إزالة من الأخيرة": "Remove from recent",
  "تمت إزالة المكالمة من الأخيرة": "Call removed from recent",
  "البحث في الأصدقاء": "Search friends",
  "لا يوجد أصدقاء مطابقون.": "No matching friends.",
  "متاح للكلام": "Available to talk",
  "عرض الأصدقاء": "View friends",
  "آخر ظهور": "Last active",
  الآن: "Just now",
  "اليوم الساعة {time}": "Today at {time}",
  "أمس الساعة {time}": "Yesterday at {time}",
  "أمس، {time}": "Yesterday, {time}",
  "{date} الساعة {time}": "{date} at {time}",
  "آخر ظهور {date}": "Last active {date}",
  رجوع: "Back",
  "أنت مسجل الدخول بالفعل": "You are already signed in",
  "التواصل مع هذا الحساب غير متاح": "Contact with this account is unavailable",
  "الإضافة موجودة بالفعل": "A connection or request already exists",
  "الإضافة غير متاحة حاليًا": "This connection is currently unavailable",
  "الصداقة غير موجودة": "Friendship not found",
  "انتظر قبل إرسال طلب آخر إلى الشخص نفسه.":
    "Wait before sending another friend request to the same person.",
  "يمكنك إرسال طلب آخر إلى {name} بعد {date}.":
    "You can send {name} another friend request after {date}.",
  "التحقق غير متاح حاليًا. حاول لاحقًا.":
    "Verification is unavailable. Try again later.",
  "أكمل التحقق ثم حاول مجددًا.": "Complete verification first, then try again.",
  "انتهت صلاحية التحقق أو أنه غير صالح. حاول مجددًا.":
    "Verification expired or was invalid. Try again.",
  "التحقق من أنك شخص حقيقي": "Verify you are human",
  "تعذر تحميل التحقق. حاول مجددًا.": "Couldn’t load verification. Try again.",
  "جارٍ تحميل التحقق…": "Preparing verification…",
  "خيارات {name}": "Options for {name}",
  "حظر الحساب": "Block user",
  "إلغاء الحظر": "Unblock",
  "إزالة الصديق": "Remove friend",
  "تم حظر الحساب": "User blocked",
  "تم إلغاء الحظر": "User unblocked",
  "تمت إزالة الصديق": "Friend removed",
  "الحسابات المحظورة": "Blocked users",
  "أنت اللي تختار": "You decide",
  "إلغاء الحظر لا يعيد الصداقة أو طلبات الإضافة.":
    "Unblocking does not restore friendships or friend requests.",
  "لا توجد حسابات محظورة.": "No blocked users.",
  "حظر {name}؟": "Block {name}?",
  "إزالة {name} من الأصدقاء؟": "Remove {name} from your friends?",
  "سيُزال من الأصدقاء ولن يتمكن من مراسلتك أو الاتصال بك. يمكنك إلغاء الحظر من الإعدادات.":
    "They’ll be removed from your friends and won’t be able to message or call you. You can unblock them in settings.",
  "ستتوقف الرسائل والمكالمات بينكما. ستحتاجان إلى طلب إضافة جديد للتواصل مجددًا.":
    "Messages and calls between you will stop. You’ll need a new friend request to reconnect.",
  "شاشة كاملة": "Full screen",
  "الخروج من ملء الشاشة": "Exit full screen",
  "تعذر فتح ملء الشاشة.":
    "Couldn’t enter full screen. The video is still expanded.",
  "الكاميرا متوقفة": "Camera off",
  "مشاركة الشاشة": "Share screen",
  "إيقاف المشاركة": "Stop sharing",
  "هذا المتصفح لا يدعم مشاركة الشاشة.":
    "Screen sharing is not supported in this browser.",
  "مشاركة الشاشة غير متاحة في هذه المكالمة. اتصل مجددًا.":
    "Screen sharing is unavailable in this call. Try calling again.",
  "تعذر بدء مشاركة الشاشة. حاول مجددًا.":
    "Couldn’t start screen sharing. Try again.",
  "شاشة {name}": "{name}’s screen",
  "{name} يشارك الشاشة": "{name} is sharing their screen",
  "معاينة شاشتك": "Your screen preview",
  شاشتك: "Your screen",
  "أنت تشارك شاشتك": "You are sharing your screen",
  "نوع المكالمة غير صحيح": "Invalid call type",
  "مكالمة فيديو": "Video call",
  "مكالمة فيديو مع {name}": "Video call with {name}",
  "فيديو {name}": "{name}’s video",
  "كاميرا الطرف الآخر متوقفة": "Your friend’s camera is off",
  "في انتظار الفيديو…": "Waiting for video…",
  "معاينة كاميرتك": "Your camera preview",
  كاميرتك: "Your camera",
  أنت: "You",
  "جارٍ تشغيل الكاميرا والميكروفون…":
    "Getting your camera and microphone ready…",
  "جارٍ توصيل الفيديو…": "Connecting video…",
  "لا تعمل كاميرتك إلا إذا رددت بالفيديو.":
    "Your camera turns on only if you answer with video.",
  "الرد بالفيديو": "Answer video",
  "صوت فقط": "Voice only",
  "تشغيل الكاميرا": "Turn camera on",
  "إيقاف الكاميرا": "Turn camera off",
  "اسمح باستخدام الكاميرا والميكروفون من إعدادات المتصفح.":
    "Allow camera and microphone access in your browser settings.",
  "لا تتوفر كاميرا أو ميكروفون. جرّب مكالمة صوتية.":
    "No camera or microphone is available. Try a voice call.",
  "لا يتوفر ميكروفون.": "No microphone is available.",
  "تعذر تشغيل الكاميرا أو الميكروفون. أغلق التطبيقات التي تستخدمهما وحاول مجددًا.":
    "Couldn’t open your camera or microphone. Close other apps using them and try again.",
  "افتح الموقع من متصفح حديث يدعم الكاميرا والميكروفون.":
    "Open the site in a modern browser that supports camera and microphone access.",
  "تعذر توصيل المكالمة على هذه الشبكة. اتصل مجددًا.":
    "Couldn’t connect the call on this network. Try calling again.",
  "تعذر توصيل المكالمة. اتصل مجددًا.":
    "Couldn’t connect the call. Try calling again.",
  "تعذر توصيل المكالمة.": "Couldn’t connect the call.",
  "خدمة المكالمات غير جاهزة. حاول لاحقًا.":
    "The calling service is getting ready. Try again later.",
  "تعذر تجهيز المكالمة. حاول مجددًا.": "Couldn’t set up the call. Try again.",
  "خدمة المكالمات غير متاحة حاليًا":
    "The calling service is currently unavailable",
  متصل: "Online",
  مشغول: "Busy",
  "غير متصل": "Offline",
  رنّة: "Ranna",
  "رنّة — الرئيسية": "Ranna — Home",
  التنقل: "Navigation",
  الأصدقاء: "Friends",
  "سجل المكالمات": "Call history",
  السجل: "History",
  "طلبات الإضافة، {count} طلبات": "Friend requests: {count}",
  حسابك: "Your account",
  "تسجيل الدخول": "Sign in",
  انضم: "Join",
  "اختر اسمك": "Pick your name",
  "جديد هنا؟ انضم": "New here? Join",
  "تواصل مع أصدقائك.": "Find a friend. Give them a ring.",
  "نتائج البحث": "Search results",
  "جاري البحث": "Searching",
  "إعادة المحاولة": "Try again",
  "عرض الرسائل الأقدم": "Show earlier messages",
  "جارٍ تحميل الرسائل…": "Loading messages…",
  "اسم المستخدم": "Username",
  "نسخ رابطك": "Copy your link",
  "متصلون الآن": "Online now",
  "يمكنك الاتصال بعد قبول طلب الإضافة.":
    "Calls start with an accepted friend request.",
  "اختبار الميكروفون": "Microphone check",
  "إغلاق التنبيه": "Dismiss notification",
  إغلاق: "Close",
  "الدخول باسم مستعار": "Join with a nickname",
  الطلبات: "Requests",
  الإعدادات: "Settings",
  رابطك: "Your link",
  "حساب جديد": "Join as a guest",
  "أدخل اسمك لإرسال طلب إضافة إلى {name}.":
    "Pick a name to send {name} a friend request.",
  "استخدم اسمًا مستعارًا للبدء.": "Just a nickname, and you’re ready to talk.",
  اسمك: "Your name",
  "الاسم الظاهر للأصدقاء": "A name you like",
  "تحديد اسم المستخدم": "Choose a username",
  اختياري: "Optional",
  "حروف إنجليزية وأرقام وشرطة سفلية، دون مسافات.":
    "Use letters a–z, numbers or underscores. No spaces.",
  متابعة: "Continue",
  "لا تحتاج إلى بريد إلكتروني أو كلمة مرور.": "No email or password needed.",
  "لا تحتاج إلى حساب أو بريد إلكتروني أو كلمة مرور.":
    "No account, email or password needed.",
  "لديك حساب؟ سجّل الدخول": "Have an account? Sign in",
  "مرحبًا بعودتك": "Welcome back",
  "أدخل رمز الاستعادة الذي حفظته.": "Enter the recovery code you saved.",
  "ادخل ببصمتك أو وجهك أو قفل الشاشة.":
    "Use your fingerprint, face or screen lock.",
  "الدخول بمفتاح مرور": "Sign in with a passkey",
  "استخدام رمز الاستعادة": "Use a recovery code",
  "رمز الاستعادة": "Recovery code",
  دخول: "Sign in",
  أصدقاؤك: "Your people",
  "لا يوجد أصدقاء حتى الآن.": "Your first friend is out there.",
  "لا يوجد أصدقاء بعد.": "No friends yet.",
  "طلبات الصداقة": "Every conversation starts with a connection",
  "تحتاج المكالمات إلى قبول طلب الإضافة.": "You choose who can call you.",
  "الطلبات المرسلة": "Sent requests",
  المكالمات: "Calls",
  "مكالمة فائتة": "Missed call",
  "مكالمة فائتة من {name}": "Missed call from {name}",
  "المكالمات الفائتة": "Missed calls",
  "المكالمات الفائتة، {count}": "Missed calls: {count}",
  "طلبات الإضافة": "Friend requests",
  رفض: "Decline",
  صادرة: "Outgoing",
  واردة: "Incoming",
  "{day}، {time}": "{day}, {time}",
  "لا توجد مكالمات بعد.": "Every friendship starts with a hello.",
  "ستظهر مكالماتك هنا.": "Your calls will appear here.",
  "رمز استعادة الحساب": "Account recovery code",
  "حالتك الآن لا تسمح بالمكالمات. اختر «متصل» من صفحة حسابك ليصلك الاتصال.":
    "Your status is blocking calls. Choose “Online” on your account page so the call reaches you.",
  "مفاتيح المرور": "Passkeys",
  "الدخول ببصمتك أو وجهك أو قفل الشاشة.":
    "Sign in with your fingerprint, face or screen lock.",
  "يصل مفتاح المرور عادةً إلى أجهزتك الأخرى من تلقاء نفسه، فلا تحفظ شيئًا ولا ترسله.":
    "A passkey usually reaches your other devices on its own, so there’s nothing to save or send.",
  "إضافة مفتاح مرور": "Add a passkey",
  "أُضيف في {date}": "Added {date}",
  "إزالة مفتاح المرور المضاف في {date}": "Remove the passkey added {date}",
  "هذا الجهاز يحمل مفتاح مرور لحسابك بالفعل.":
    "This device already has a passkey for your account.",
  "تعذر استخدام مفتاح المرور على هذا الجهاز.":
    "Couldn’t use a passkey on this device.",
  "احتياطي للدخول من أي جهاز دون مفتاح مرور.":
    "A backup to sign in on any device without your passkey.",
  اللغة: "Language",
  "آخر ظهور وحالة القراءة": "Last active and read status",
  "يرى أصدقاؤك متى كنت متصلًا آخر مرة وهل قرأت رسائلهم. يُخفى ذلك عند الظهور كغير متصل.":
    "Friends can see when you were last active and whether you've read their messages. Hidden when you appear offline.",
  "العثور عليك باسم المستخدم": "Let people find you by username",
  "يجدك من يكتب اسم المستخدم كاملًا. عند الإيقاف يضيفك الآخرون عبر روابطك فقط.":
    "Anyone who types your whole username can find you. When it’s off, people can add you only through your links.",
  "يراه أصدقاؤك ومن يجد حسابك باسم المستخدم أو برابطه.":
    "Friends see this, and so does anyone who finds you by username or your profile link.",
  "يمكن تغييره مرة واحدة كل ٢٤ ساعة.": "You can change it once every 24 hours.",
  "تسجيل الخروج دون طريقة للعودة؟": "Sign out with no way back?",
  "بدون مفتاح مرور أو رمز استعادة لن تتمكن من العودة إلى هذا الحساب بعد تسجيل الخروج.":
    "Without a passkey or a recovery code, you can’t get back into this account after you sign out.",
  "تسجيل الخروج على أي حال": "Sign out anyway",
  "حذف الحساب": "Delete account",
  "حذف حسابك نهائيًا؟": "Delete your account permanently?",
  "ستُحذف رسائلك وأصدقاؤك وسجل مكالماتك ومفاتيح المرور ورمز الاستعادة من رنّة، وتختفي محادثاتك من عند أصدقائك أيضًا. لا يمكن التراجع عن ذلك.":
    "Your messages, friends, call history, passkeys and recovery code will be removed from Ranna, and your conversations will disappear for your friends too. This can't be undone.",
  "الإبقاء على حسابي": "Keep my account",
  "حذف حسابي نهائيًا": "Delete my account",
  "احتفظ بهذا الرمز في مكان آمن. يتيح لك الدخول من أي جهاز، وإنشاء رمز جديد يلغي السابق.":
    "Keep this code private. Use it to return on any device. Creating a new code replaces the old one.",
  "الرمز الجديد يلغي السابق.": "A new code replaces the old one.",
  "خرجت أجهزتك الأخرى، لكن من يملك رمز الاستعادة يستطيع الدخول مجددًا. إذا لم تكن متأكدًا من يملكه، فأنشئ رمزًا جديدًا يحل محله.":
    "Your other devices are signed out, but anyone with your recovery code can still sign in. If you’re not sure who has it, create a new one to replace it.",
  "رمز الاستعادة الجديد": "New recovery code",
  "حدد الرمز وانسخه يدويًا.": "Select the code and copy it manually.",
  "نسخ الرمز": "Copy code",
  إنشاء: "Create",
  "إنشاء رمز استعادة جديد": "Create a new recovery code",
  حفظ: "Save",
  "حفظ رمز الاستعادة": "Save a recovery code",
  "لا توجد طريقة للعودة إلى حسابك بعد":
    "You have no way back into your account yet",
  "إذا مسحت بيانات المتصفح أو فقدت جهازك أو غبت عنه سنة، ستفقد حسابك وأصدقاءك ومحادثاتك. مفتاح المرور يعيدك إليه ببصمتك أو وجهك أو قفل الشاشة.":
    "If you clear your browser data, lose your device or stay away from it for a year, you lose your account, friends and conversations. A passkey brings you back with your fingerprint, face or screen lock.",
  "إذا مسحت بيانات المتصفح أو فقدت جهازك أو غبت عنه سنة، ستفقد حسابك وأصدقاءك ومحادثاتك. احفظ رمز الاستعادة في مكان خاص لتعود به من أي جهاز.":
    "If you clear your browser data, lose your device or stay away from it for a year, you lose your account, friends and conversations. Save the recovery code somewhere private to get back in from any device.",
  "ذكّرني لاحقًا": "Remind me later",
  "تنزيل الرمز": "Download code",
  "مشاركة رابط الحساب": "Share profile link",
  "رابط حسابك": "Your profile link",
  "إضافة صديق": "Add a friend",
  "أرسل رابط حسابك أو اعرض رمز QR. من يفتحه يمكنه أن يرسل إليك طلب إضافة.":
    "Send your profile link or show your QR code. Whoever opens it can send you a friend request.",
  "رمز QR لرابط حسابك": "QR code for your profile link",
  "أضفني إلى أصدقائك على رنّة": "Add me as a friend on Ranna",
  // Apps show these when a profile link is pasted.
  "أضف {name} إلى أصدقائك على رنّة": "Add {name} as a friend on Ranna",
  "تحدث بالصوت أو الفيديو وراسل أصدقاءك باسمك فقط، دون بريد إلكتروني أو كلمة مرور.":
    "Talk by voice or video and message your friends with just a name. No email or password needed.",
  "جارٍ تجهيز رابط حسابك": "Getting your profile link ready",
  "تعذر تجهيز رابط حسابك.": "Couldn’t get your profile link ready.",
  "إعادة تعيين الرابط": "Reset link",
  "إعادة تعيين رابط حسابك؟": "Reset your profile link?",
  "سيتوقف رابطك الحالي ورمز QR عن العمل، وتحصل على رابط جديد. من أصبحوا أصدقاءك يبقون كذلك.":
    "Your current link and QR code will stop working, and you’ll get a new link. Your friends stay your friends.",
  "تم تغيير رابط حسابك. الرابط السابق لم يعد يعمل.":
    "Your profile link changed. The old one no longer works.",
  "اسم مستخدم صديقك": "Your friend’s username",
  "أو دع صديقك يضيفك": "Or let them add you",
  "أرسل إليه رابط حسابك أو اعرض رمز QR.":
    "Send them your profile link or show your QR code.",
  "باسم المستخدم أو برابط حسابك": "By username or your profile link",
  "أنت على الخط": "You’re on the line",
  "جارٍ إعادتك إلى الخط…": "Getting you back on the line…",
  "نسخ اسم المستخدم": "Copy username",
  "تعذر نسخ اسم المستخدم.": "Couldn’t copy your username.",
  بحث: "Find",
  "اكتب اسم المستخدم كاملًا كما هو.": "Type their whole username.",
  "لم نجد أحدًا باسم المستخدم {username}.":
    "We couldn’t find anyone with the username {username}.",
  "تأكد من كتابته كاملًا، أو اطلب رابط حسابه. قد لا يظهر بعض الأشخاص في البحث.":
    "Check that it’s complete, or ask them for their profile link. Some people choose not to be found.",
  "شارك رابط حسابك، أو أضف صديقًا باسم المستخدم.":
    "Share your profile link, or add a friend by their username.",
  "رابط الحساب غير صحيح": "Invalid profile link",
  "رابط الحساب غير متاح. ربما غيّره صاحبه أو لم يعد صالحًا.":
    "This profile link isn’t available. Its owner may have reset it.",
  "يمكن إضافة هذا الحساب عبر رابط حسابه فقط.":
    "This person can only be added through their profile link.",
  "نسخ الرابط": "Copy link",
  "مشاركة…": "Share…",
  "حدد الرابط وانسخه يدويًا.": "Select the link and copy it manually.",
  "تعذرت المشاركة. انسخ الرابط وأرسله إلى صديقك.":
    "Couldn’t share. Copy the link and send it to your friend.",
  "تسجيل الخروج": "Sign out of this browser",
  تفضيلاتك: "Make yourself at home",
  حالتك: "Your status",
  "نبذة عنك": "About you",
  "حفظ التغييرات": "Save changes",
  "محادثتك مع {name}": "Chat with {name}",
  "راسل {name}": "Message {name}",
  "اتصل بـ{name}": "Call {name}",
  اتصل: "Call",
  فيديو: "Video",
  راسل: "Message",
  "بانتظار قبول {name} لطلبك.": "Waiting for {name} to accept.",
  "أرسل {name} إليك طلب إضافة.": "{name} sent you a friend request.",
  "أضف {name} لتتمكنا من الاتصال والمراسلة.":
    "Add {name} to call and message each other.",
  "رفض طلب {name}": "Decline {name}’s request",
  قبول: "Accept",
  "إلغاء الطلب": "Cancel request",
  "طلب مُرسل": "Requested",
  "إلغاء طلب {name}": "Cancel request to {name}",
  الحساب: "Account",
  "{count} غير مقروءة": "{count} unread",
  مقروءة: "Read",
  "أنت: {message}": "You: {message}",
  اليوم: "Today",
  أمس: "Yesterday",
  "{name} يتصل بك…": "{name} is calling…",
  "مكالمة صوتية واردة": "Incoming voice call",
  "مكالمة فيديو واردة": "Incoming video call",
  الإشعارات: "Notifications",
  "لا توجد إشعارات بعد.": "No notifications yet.",
  "كل جديد، في مكان واحد.": "Everything new, in one place.",
  "الإشعارات مفعّلة لهذا المتصفح.": "Notifications are on for this browser.",
  "الإشعارات محظورة في إعدادات المتصفح.":
    "Notifications are blocked in your browser settings.",
  "نبّهني بالمكالمات والرسائل عندما تكون رنّة في الخلفية.":
    "Get alerts for calls and messages while Ranna is in the background.",
  تفعيل: "Turn on",
  "نبّهني بالمكالمات والرسائل ودعوات المكالمات الجماعية حتى عندما تكون رنّة مغلقة.":
    "Get alerts for calls, messages and group invitations, even when Ranna is closed.",
  "تصلك المكالمات والرسائل ودعوات المكالمات الجماعية على هذا الجهاز حتى عندما تكون رنّة مغلقة.":
    "Calls, messages and group invitations reach this device, even when Ranna is closed.",
  إيقاف: "Turn off",
  "تعذر تفعيل الإشعارات. حاول مجددًا.":
    "Couldn’t turn on notifications. Try again.",
  "تعذر إيقاف الإشعارات. حاول مجددًا.":
    "Couldn’t turn off notifications. Try again.",
  إضافة: "Add",
  "لا توجد رسائل بعد.": "No messages yet.",
  رسالتك: "Your message",
  "اكتب رسالة…": "Write a message…",
  "إرسال الرسالة": "Send message",
  "لم تُرسل": "Not sent",
  "لم تُرسل رسالتك إلى {name}": "Your message to {name} wasn’t sent",
  إزالة: "Remove",
  "مكالمة صوتية": "Voice call",
  "الميكروفون يعمل. تحدث وشاهد الموجة.":
    "Microphone is on. Speak and watch the wave.",
  "اسمح باستخدام الميكروفون إذا طلب المتصفح ذلك.":
    "Allow microphone access if your browser asks.",
  "الاختبار متوقف. اضغط «بدء الاختبار» للمتابعة.":
    "Test stopped. Select “Start test” to continue.",
  "جارٍ تشغيل الميكروفون…": "Getting your microphone ready…",
  "جارٍ توصيل الصوت…": "Connecting audio…",
  "مكالمة واردة…": "Incoming call…",
  "جارٍ الاتصال…": "Ringing…",
  "مستوى صوت الميكروفون": "Microphone level",
  "بدء الاختبار": "Start test",
  "إيقاف الاختبار": "Stop test",
  "توقف الميكروفون. أعد تشغيل الاختبار للمحاولة مجددًا.":
    "Your microphone stopped. Start the test again to retry.",
  رد: "Answer",
  "توقف الميكروفون. لا يستطيع الطرف الآخر سماعك.":
    "Your microphone stopped. The other person can’t hear you.",
  "إعادة تشغيل الميكروفون": "Restart microphone",
  "جارٍ إعادة تشغيل الميكروفون…": "Restarting microphone…",
  "إلغاء الكتم": "Unmute",
  "كتم الصوت": "Mute",
  "تشغيل الصوت": "Play audio",
  "كتم السماعة": "Mute speaker",
  "تعذر تشغيل صوت الطرف الآخر. اضغط على «تشغيل الصوت» للمحاولة مجددًا.":
    "Your friend’s audio could not play. Tap “Play audio” to try again.",
  إنهاء: "End call",
  "إنهاء المكالمة مع {name}؟": "End the call with {name}?",
  "إنهاء الآن": "End now",
  "تصغير المكالمة": "Minimize call",
  "العودة إلى المكالمة": "Return to call",
  "المكالمة مع {name}": "Call with {name}",
  "يتم الاختبار على جهازك دون تسجيل الصوت.":
    "This check stays on your device. Nothing is recorded.",
  "تعذر الاتصال. أعد تحميل الصفحة.":
    "Couldn’t connect. Try refreshing the page.",
  "انتهت جلسة الدخول. استخدم رمز الاستعادة للدخول مجددًا.":
    "Your session ended. Use your recovery code to return.",
  "تم إرسال طلب إضافة إلى {name}": "Friend request sent to {name}",
  "مرحبًا، {name}": "Welcome, {name}",
  "تم تسجيل الدخول": "Signed in",
  "تم إرسال طلب الإضافة": "Friend request sent",
  "تمت إضافة {name} إلى الأصدقاء": "Added {name} to friends",
  "تم رفض الطلب": "Request declined",
  "تم إلغاء الطلب": "Request cancelled",
  "غير متاح حاليًا. يمكنك إرسال رسالة.":
    "They’re unavailable right now. You can send a message.",
  "تم حفظ التغييرات": "Changes saved",
  "صورة الحساب": "Profile picture",
  "تغيير صورة الحساب": "Change profile picture",
  "تعديل الحساب": "Edit profile",
  "يمكنك تغيير اسم المستخدم مجددًا بعد {date}.":
    "You can change your username again after {date}.",
  "اختر صورة يراها أصدقاؤك بجانب اسمك.":
    "Pick an avatar your friends see next to your name.",
  "صورة غير صحيحة": "Invalid picture",
  "الأحرف الأولى": "Initials",
  ذكر: "Male",
  أنثى: "Female",
  "صورة {number}": "Avatar {number}",
  "تم تسجيل الخروج": "Signed out of this browser",
  "تم حذف حسابك": "Your account was deleted",
  "حدثت مشكلة في الاتصال": "There was a connection problem",
  "تعذر الوصول إلى رنّة": "Can’t reach Ranna",
  "تحقق من اتصالك بالإنترنت وحاول مجددًا.":
    "Check your internet connection and try again.",
  "جارٍ إعادة المحاولة…": "Trying again…",
  "انتهت المكالمة على جهازك.": "The call has ended on your device.",
  "لا يوجد رد. حاول لاحقًا.": "No answer right now. Try again in a little while.",
  "الطرف الآخر مشغول حاليًا": "Your friend is busy right now",
  "الاتصال انقطع وانتهت المكالمة.": "The connection dropped and the call ended.",
  "المكالمة انتهت": "Call ended",
  "اتصل مجددًا": "Call again",
  "تم النسخ": "Copied",
  "اختبر الصوت واختر أجهزتك": "Test your sound and choose your devices",
  "تبديل الكاميرا": "Switch camera",
  الميكروفون: "Microphone",
  الكاميرا: "Camera",
  "مكبر الصوت": "Speaker",
  "الافتراضي في الجهاز": "Device default",
  "صوت {name} مكتوم": "{name} is muted",
  "جارٍ استعادة الاتصال…": "Reconnecting call…",
  "تعذر استعادة الاتصال. اتصل مجددًا.":
    "Couldn’t restore the connection. Try calling again.",
  "تم الرد على المكالمة من جهاز آخر.":
    "The call was answered on another device.",
  "تعذر توصيل الصوت. اتصل مجددًا.": "Couldn’t connect audio. Try calling again.",
  "تعذر توصيل الصوت.": "Couldn’t connect audio.",
  "افتح الموقع من متصفح حديث يدعم الميكروفون.":
    "Open the site in a modern browser that supports microphone access.",
  "تم إلغاء المكالمة": "Call cancelled",
  "تعذر إرسال بيانات الاتصال.": "Couldn’t send the connection details.",
  "تعذر توصيل الصوت على هذه الشبكة. اتصل مجددًا.":
    "Couldn’t connect audio on this network. Try calling again.",
  "جارٍ تجهيز الاتصال. حاول بعد لحظة.":
    "The connection is getting ready. Try again in a moment.",
  "لا يوجد رد.": "No answer right now.",
  "اسمح باستخدام الميكروفون من إعدادات المتصفح.":
    "Allow microphone access in your browser settings.",
  "تعذر بدء المكالمة": "Couldn’t start the call",
  "انتهت المكالمة أو تم الرد عليها.": "The call ended or was already answered.",
  "تعذر توصيل الصوت. حاول مجددًا.": "Couldn’t connect audio. Try again.",
  "تعذر الرد": "Couldn’t answer the call",
  "طلبات كثيرة. حاول بعد لحظة.": "A little too fast. Try again in a moment.",
  "أنشئ حسابًا لبدء المحادثة": "Pick a name before you start talking",
  "الطلب أكبر من المسموح": "The request is too large",
  "طلب غير مسموح": "This request is not allowed",
  "حدثت مشكلة في الاتصال. حاول مجددًا.":
    "There was a connection problem. Try again.",
  "المسار غير موجود": "Page not found",
  "بيانات غير صحيحة": "Invalid details",
  "الحساب غير موجود": "Account not found",
  "هذه الصفحة لمشرفي رنّة فقط": "This page is for Ranna administrators only",
  "أضف هذا الشخص إلى أصدقائك لبدء المحادثة":
    "Add each other before you start talking",
  "المكالمة متاحة بين الأصدقاء بعد قبول الإضافة":
    "Calls are available after a friend request is accepted",
  "خدمة الصوت غير جاهزة. حاول لاحقًا.":
    "The audio service is getting ready. Try again later.",
  "تعذر تجهيز الصوت. حاول مجددًا.": "Couldn’t set up audio. Try again.",
  "خدمة توصيل الصوت غير متاحة حاليًا":
    "The audio service is currently unavailable",
  "طلب غير صحيح": "Invalid request",
  "أدخل اسمًا من حرفين على الأقل. اسم المستخدم اختياري ويتكون من ٣ إلى ٢٤ حرفًا إنجليزيًا أو رقمًا أو شرطة سفلية.":
    "Choose a name with at least 2 characters. An optional username must be 3–24 characters using a–z, numbers or underscores.",
  "أدخل اسمًا من حرفين على الأقل واسم مستخدم من ٣ إلى ٢٤ حرفًا إنجليزيًا أو رقمًا أو شرطة سفلية.":
    "Choose a name with at least 2 characters and a username of 3–24 characters using a–z, numbers or underscores.",
  "اسم المستخدم مستخدم بالفعل. اختر اسمًا آخر.":
    "That username is taken. Try another one.",
  "يمكن تغيير اسم المستخدم مرة واحدة كل ٢٤ ساعة.":
    "You can change your username once every 24 hours.",
  "رمز الاستعادة غير صحيح": "Invalid recovery code",
  "تعذر إضافة مفتاح المرور. حاول مجددًا.":
    "Couldn’t add the passkey. Try again.",
  "تعذر الدخول بمفتاح المرور. حاول مجددًا أو استخدم رمز الاستعادة.":
    "Couldn’t sign in with that passkey. Try again or use your recovery code.",
  "رمز الاستعادة غير صحيح أو تم استبداله":
    "That recovery code is invalid or has been replaced",
  "حالة غير صحيحة": "Invalid status",
  "الطلب غير موجود": "Request not found",
  "يجب قبول طلب الإضافة أولًا": "Accept the friend request first",
  "اكتب رسالتك أولًا": "Write your message first",
  "طلب غير معروف": "Unknown request",
  "اتصال غير مسموح": "This connection is not allowed",
  "تعذر توصيل المكالمة. حاول مجددًا.": "Couldn’t connect the call. Try again.",
  "المكالمة غير موجودة": "Call not found",
  "المكالمة موجودة بالفعل": "The call already exists",
  "يجب أن يقبل الطرف الآخر طلب الإضافة قبل الاتصال":
    "Your friend needs to accept your request before you can call",
  "صديقك غير متاح حاليًا. يمكنك إرسال رسالة.":
    "Your friend is unavailable right now. You can send a message.",
  "هذا المتصفح لا يدعم الإشعارات": "This browser doesn’t support notifications",
  "الإشعارات غير متاحة حاليًا": "Notifications aren’t available right now",
  "بيانات اتصال غير صحيحة": "Invalid connection details",
  "توجد مكالمة جارية بالفعل. حاول لاحقًا.":
    "There’s already a call in progress. Try again later.",
  "بدأت مكالمة للتو. حاول مجددًا.": "A call just started. Try again.",
  "انتهت المكالمة أو تم الرد عليها من جهاز آخر":
    "The call ended or was answered on another device",
  "بيانات الاتصال أكبر من المسموح": "The connection details are too large",
  "تم تجاوز حد بيانات الاتصال": "Too many connection updates",
  "تعذر إرسال بيانات الاتصال": "Couldn’t send the connection details",
  "رنّة | على الخط": "Ranna | On the line",
  "مكالمات صوتية مع أصدقائك.":
    "Find a friend, connect and give them a ring. One-to-one voice calls with just a nickname.",
  "مكالمات صوت وفيديو": "Voice & video calls",
};

export type Locale = "ar" | "en";
export const localeTag = (locale: Locale) =>
  locale === "ar" ? "ar-EG" : "en-US";
export function resolveLocale(
  query: string | null,
  saved: string | null,
  languages: readonly string[],
): Locale {
  if (query === "ar" || query === "en") return query;
  if (saved === "ar" || saved === "en") return saved;
  return languages[0]?.toLowerCase().startsWith("ar") ? "ar" : "en";
}
export function translate(
  source: string,
  locale: Locale,
  params: Record<string, string | number> = {},
) {
  const phrase = locale === "en" ? (english[source] ?? source) : source;
  return phrase.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.hasOwn(params, key) ? String(params[key]) : match,
  );
}
